export default __webpack_public_path__ + "static/media/TBTC_WBTC_SBTC_pool.dad04fbb.svg";